import React from 'react';
import { TechnicianColorPicker } from '../technician-color-picker/technician-color-picker.component';

interface TechnicianColorCellProps {
  userId: string;
  customColors?: Record<string, string>;
  onColorChange: (userId: string, color: string | null) => void;
  disabled?: boolean;
}

export const TechnicianColorCell: React.FC<TechnicianColorCellProps> = ({ 
  userId, 
  customColors, 
  onColorChange, 
  disabled = false 
}) => {
  const currentCustomColor = customColors?.[userId] || undefined;

  const handleColorSelect = (color: string | null) => {
    onColorChange(userId, color);
  };

  return (
    <TechnicianColorPicker
      userId={userId}
      currentColor={currentCustomColor}
      onColorSelect={handleColorSelect}
      disabled={disabled}
    />
  );
};